import { removeDuplicates } from '@/common/util/util.js';


export const emptyModel = () => ({
    type: null,
    main: false,
    contact: {
        fio: '',
        phone: '',
        email: '',
        post: '',
        extra: '',
        id: null,
    },
});

export const CONTACT_TYPES = Object.freeze({
    manager: 'manager',
    default: 'default',
});


export function removeDuplicateContacts(contacts) {
    const map = new Map();
    const result = [];

    for (const contact of contacts) {
        if (!map.has(contact.contact.id)) {
            map.set(contact.contact.id, contact);
            result.push(contact);
        }
    }

    return removeDuplicates(result);
}
